
$(document).ready(function () 
{
	$('#submit2').click(function () 
	{
		//console.log('clk');
		checkNewInputs();
	});

	$('#new-name').on('keypress', function(e)
	{
		if (e.keyCode == 13)
		{
			//console.log(13);
			checkNewInputs();
		} //if
	});
});

	function ajaxCheckNewName() 
	{
		$.ajax(
		{
			url: '/reg?act=check&new[name]=' + $('#new-name').val() + '&chk_new=1', 
			cache: false,
			type: 'POST',
			success: function(serverData, status) 
			{
				showLoading(2,0);
				if (serverData === "0" || serverData === 0) 
				{
					regUser();
				} 
				else 
				{
					$('#new-name-error3').css("display", "block");
					return false;
				}
			}
		});
	}

	var posted = false;
	
	function suggestUser()
	{
		console.log('SUGGEST');
		$.ajax(
		{
			url: '/reg?act=suggest', 
			cache: false,
			type: 'GET',
			dataType: 'json',
			success: function(serverData, status) 
			{
				$('#new-name').val(serverData);
			}
		});
	} //function

	function regUser() 
	{
		$.ajax({
			url: '/reg?act=reg&new[name]='+$('#new-name').val(), 
			cache: false,
			type: 'POST',
			success: function(serverData, status) 
			{
				showLoading(2,0);
				if (serverData === 1 || serverData === "1") 
				{
					$('#messageboxChooseUsername.messagebox .innerbox .content').html("Gratulálunk. Sikeres regisztráció.");
					_gaq.push(['_trackEvent', 'Regisztráció', 'ForcedRegSucces', IVUser.page]);
					setTimeout(function() {
						window.location.href = window.location;	
					},1500);
				} 
				else 
				{
					$('#new-name-error3').html("Valami hiba történt. Próbáld meg később.");
					$('#new-name-error3').css("display", "block");
				}
			} 
		});
	}

	//-------------------------------------------------------------------//

	function showCheckNewName(o) 
	{
		this.showLoading(2,0);

		if(o.responseText === 0) 
		{
			
		}
		else 
		{
			$('new-name-error3').style.display = 'block';
			return false;
		} //if
	} //function

	//-------------------------------------------------------------------//

	function showLoading(id,state) 
	{
		switch(state) 
		{
			case 0 : 
				$('#loading'+id).css("display", "none");
				$('#submit'+id).css("display", "block");
			break;
				$('#loading'+id).css("display", "block");
				$('#submit'+id).css("display", "noe");
		}
	}

	//-----------------------------------------------------------------//

	function elimSpecChars(parent) 
	{
		var to = new Array('i','e','a','u','o','u','o','u','o','I','E','A','U','O','U','O','U','O','');
		var string = parent.value;

		for(i=0; i < g_utf8_hunchars.length; i++) {
			string = this.replaceAll(string,g_utf8_hunchars[i],to[i]);
		}

		parent.value = string;
	}

	//-----------------------------------------------------------------//

	function replaceAll(string,from,to) 
	{
		var idx = string.indexOf(from);

		while ( idx > -1 ) {
			string = string.replace(from,to);
			idx = string.indexOf(from);
		}
		return string;
	}

	function isValidNameChars(string) 
	{
		var myregExp = /^([a-zA-Z0-9_]+)$/;
		return myregExp.test(string);
	}

	function checkNewInputs() 
	{
		_gaq.push(['_trackEvent', 'Regisztráció', 'ForcedRegTry', IVUser.page]);

		// console.log(arguments.callee.caller.toString());
		$('#new-name-error1').css("display", "none");
		$('#new-name-error2').css("display", "none");
		$('#new-name-error3').css("display", "none");

		if($('#new-name').val().length === 0) 
		{
			$('#new-name-error2').css("display", "none");
			$('#new-name-error1').css("display", "block");
			return false;
		}
		else 
		{
			$('#new-name-error1').css("display", "none");

			if(isValidNameChars($('#new-name').val()) === false) 
			{
				$('#new-name-error2').css("display", "block");
				return false;
			}
			else 
			{
				$('#new-name-error2').css("display", "none");
				showLoading(2,1);
				ajaxCheckNewName();
			} //if
		} //if
	} //function
